
<div class="web-view" 
fxHide.xs fxHide.sm   fxHide.lt-md fxFlex.md > 

    <div class="navbar-div">
        <app-web-navbar></app-web-navbar>
    </div>


    <div class="main-div" fxLayout="row wrap" >
         
        <div fxLayout="row">
        <div fxLayout="column wrap" class="description-div" >
            <h1 class="heading">Cinejoy Screening Parties</h1>
            <p >
                Join or Host an exciting Cinejoy Screening Party! Screening Parties are fun and welcoming gatherings of new and old friends to discuss/share your thoughts and feelings about a great Cinejoy Movie. Hosts can choose their Cinejoy Movie for discussion and the time/date for the party.
                <br><br>
                Party participants can choose amongst the schedule of parties and their associated movies and must agree to watch the movie prior to the party—other than the cost of the movie viewing, parties are free.
            </p>
        </div>

        <div class="image-div" fxLayout="column wrap" >

            <img class="image" src="assets/images/cinejoy/Hero-popcorn.png" alt="Cinejoy Home Page Image">

        </div>
        </div>
        <div  fxLayout="row wrap" class="button-main-div" >
            <div fxLayout="row wrap" class="button-div" fxLayoutAlign="start center"  fxLayoutGap="50px">
            <button class="btn" (click)="gotoJoin()" ><span class="btn_effect">Join a Screening Party</span></button>
            <button class="btn" (click)="gotoHost()"><span class="btn_effect">Host a Screening Party</span></button>
        </div>
        </div>

        
    </div>

    <div class="footer-div" > 
        <app-cinejoy-footer></app-cinejoy-footer>
    </div>


</div>
                            <!-- wev view ended -->

                         <!-- mobile view started -->

<div class="mobile-view" 
                            fxHide.lg 
                            fxHide.md 
                            fxHide.lt 
                            fxFlex.lt-md
                            fxShow.xs  
                            fxHide.gt-lg >

    <div class="mobile-navbar">
        <app-sidebar></app-sidebar>
    </div>

    <div class="navbar-div">
        <app-web-navbar></app-web-navbar>
    </div>

    <div class="main-div-mob" fxLayout="column wrap">
            
        <div fxLayout="column">

            <div class="image-div-mob" fxLayout="column" fxLayoutAlign="start center">

                <img class="image-mob" src="assets/images/cinejoy/Hero-popcorn.png" alt="Cinejoy Home Page Image">
        
            </div>
        
            <div fxLayout="column" class="description-div-mob" >

                <h1 class="heading-mob">Cinejoy Screening Parties</h1>

                <p class="description">
                    Join or Host an exciting Cinejoy Screening Party! Screening Parties are fun and welcoming gatherings of new and old friends to discuss/share your thoughts and feelings about a great Cinejoy Movie. Hosts can choose their Cinejoy Movie for discussion and the time/date for the party.
                <br><br>
                    Party participants can choose amongst the schedule of parties and their associated movies and must agree to watch the movie prior to the party—other than the cost of the movie viewing, parties are free.
                </p>
            </div>

            <div fxLayout="column wrap" class="button-div-mob" fxLayoutGap="10px">

                <button class="mobileBtn" (click)="gotoJoin()">Join a Screening Party </button>
                <button class="mobileBtn" (click)="gotoHost()">Host a Screening Party</button>
                
                
            </div>

        </div>

    </div>


    <div class="footer-div">
        <app-cinejoy-mobile-footer></app-cinejoy-mobile-footer>
    </div>
    
</div>